<template>
    <div class="md-mid-banner standard" :style="{ marginBottom }">
        <module-box :fullColumn="fullColumn" noPadding noMargin>
            <site-img
                class="container"
                type="bgImg"
                :src="suitableImg"
                dir="width"
            >
                <div class="title" v-if="title" v-html="title"></div>
                <h3 class="subtitle">
                    {{ listingDetail.info && listingDetail.info.streetAddress }}
                </h3>
                <button
                    class="gotour"
                    @click="goTour"
                    :style="{ backgroundColor: button.color }"
                    v-html="button.text"
                ></button>
            </site-img>
        </module-box>
    </div>
</template>
<script>
import Common from '../index.js';
export default {
    mixins: [Common]
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-mid-banner.standard {
    .container {
        height: 300px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title {
            font-size: 36px;
            font-family: var(--mg-title-font);
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            width: 80%;
            text-align: center;
            @include color-theme();
            @include ellipsis;
        }
        .subtitle {
            font-size: 18px;
            font-family: var(--font-medium);
            margin-top: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: white;
        }
        .gotour {
            @include color-button-hover();
            color: #fff;
            font-size: 16px;
            font-family: var(--font-bold);
            margin-top: 30px;
            padding: 0 20px;
            min-width: 190px;
            max-width: 80%;
            text-align: center;
            text-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
            min-height: 40px;
            @include color-button();
        }
    }

    @include media-600 {
        display: none;
    }
}
</style>
